import * as React from "react";

function SvgBroom({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M12 1.25a2.25 2.25 0 012.245 2.096l.005.154v5.8c.479.118.89.434 1.126.875l.072.151.417 1c.157.376.176.788.064 1.169a4.748 4.748 0 013.186 3.756l.03.224.358 3.221a2.75 2.75 0 01-2.543 3.048l-.195.006h-9.53a2.752 2.752 0 01-2.748-2.86l.015-.194.358-3.22a4.75 4.75 0 013.211-3.98 1.75 1.75 0 01.005-1.006l.059-.164.417-1c.217-.52.666-.895 1.198-1.026V3.5c0-1.11.806-2.041 1.91-2.222l.16-.02.18-.008zm2.42 12.5H9.58l-.183.005a3.25 3.25 0 00-3.021 2.705l-.026.18-.358 3.222-.007.132a1.246 1.246 0 001.118 1.249l.132.007h.515V20l.007-.102a.75.75 0 011.486 0L9.25 20v1.25h2V20l.007-.102a.75.75 0 011.486 0l.007.102v1.25h2V20l.007-.102a.75.75 0 011.486 0l.007.102v1.25h.517l.133-.007a1.249 1.249 0 001.12-1.248l-.007-.133-.358-3.221-.026-.181a3.25 3.25 0 00-3.209-2.71zm-.587-3h-3.666a.253.253 0 00-.202.102l-.029.052-.417 1a.249.249 0 00.17.338l.061.008h4.5a.25.25 0 00.248-.287l-.017-.06-.417-1a.251.251 0 00-.231-.153zm-1.83-8l-.076.003a.751.751 0 00-.67.643l-.007.104v5.75h1.5V3.5a.75.75 0 00-.55-.723l-.098-.02-.099-.007z"
        />
      </g>
    </svg>
  );
}

export default SvgBroom;
